<template>
    <div class="MaintainList">
        <div class="create_maintain">
            <router-link class="btn btn_mystyle" :to="{ name: 'MaintainCreate' }">
                我要報修
            </router-link>
            <router-link  class="btn send_div" :to="{ name: 'MemberHome' }">
                返回
            </router-link>
        </div>
        <div class="maintain_content">
            <div class="div_table">
                <table class="table" ref="oTable">
                    <thead>
                        <tr>
                            <th>項次</th>
                            <th>通報人</th>
                            <th>通報時間</th>
                            <th>通報單號</th>
                            <th>維修單狀態</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="item in maintain_list" :key="item.id">
                            <td>
                                {{ item.order }}
                            </td>
                            <td>
                                {{ item.notify_name }}
                            </td>
                            <td>
                                {{ item.notify_time }}
                            </td>
                            <td>
                                {{ item.notify_number }}
                            </td>
                            <td>
                                <router-link class="btn" :class="status_btn_style[item.maintain_status]" :to="{ name: 'MaintainContent', params: {id: parseInt(item.id)} }">
                                    {{maintain_status_btn[item.maintain_status]}}
                                </router-link>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
// import 'bootstrap';
// import 'bootstrap/dist/css/bootstrap.min.css';
import "datatables.net-dt/js/dataTables.dataTables"
import "datatables.net-dt/css/jquery.dataTables.min.css"
import "@/assets/css/member/maintain/maintainList.css";

export default {
    name: "MaintainList",
    data: function () {
		return {
            maintain_status_btn: ['未受理', '已受理', '已指派', '維修中', '維修中', '已完工'],
            status_btn_style: ['btn-danger', 'btn-success', 'btn-warning', 'btn-info', 'btn-info', 'btn-primary'],
            maintain_list: []
		};
	},
    beforeMount: function () {
        if (this.$route.name == 'MemberHome' && !localStorage.getItem('house_number') && this.$store.state.house_number == null) {
            this.$router.push({ name: 'Login' });
        } else {
            const getData = new FormData();
            getData.append('CMD' , 'FrontMemberHomeMaintainList');
            if (localStorage.getItem('house_number') != null) {
                getData.append('house_number' , localStorage.getItem('house_number'));
            }
            this.$axios.post(process.env.VUE_APP_FROENT_API_PREFIX, getData)
            .then(response => {
                // console.log(response);
                this.maintain_list = response.data.maintain_list;
                this.$nextTick(() =>{ //請求成功的回調里使用
                    $(this.$refs.oTable).DataTable({
                        searching: false, //搜尋功能, 預設是開啟
                        paging: true, //分頁功能, 預設是開啟
                        ordering: false, //排序功能, 預設是開啟
                        lengthMenu: [10, 20],
                        language: {
                            processing: "處理中...",
                            loadingRecords: "載入中...",
                            lengthMenu: "一頁顯示 _MENU_ 筆",
                            zeroRecords: "沒有數據....",
                            info: "第 _START_ ~ _END_ 筆，共 _TOTAL_ 筆",
                            infoEmpty: "",
                            infoFiltered: "(從 _MAX_ 項結果中過濾)",
                            infoPostFix: "",
                            search: "搜尋:",
                            paginate: {
                                first: "第一頁",
                                previous: "上一頁",
                                next: "下一頁",
                                last: "最後一頁"
                            }
                        }
                    });
                })
            })
            .catch(error => {
                console.log(error);
            })
        }
    },
    watch : {},
    beforeDestroy : function () {
        $('#datatable').DataTable({
            destroy: true
        });
    }
}
</script>

<style>
    
</style>